"use client"

import { useState } from "react"
import { Button, Card, Input, Select, Tag, Tabs, Switch, Radio, Title, Progress } from "animal-island-ui"

export default function ThemePreviewPage() {
  const [server, setServer] = useState("0")
  const [payType, setPayType] = useState<string | number>("wechat")

  return (
    <div style={{ minHeight: "100dvh", background: "linear-gradient(160deg, var(--blush-100) 0%, var(--blush-200) 100%)", padding: "32px" }}>
      <div style={{ maxWidth: 960, margin: "0 auto" }}>
        <Title size="large" color="warm-peach-pink" style={{ marginBottom: 8 }}>
          🎀 艾艾代肝小店 · 动物森友会风格预览
        </Title>
        <p style={{ color: "var(--berry-600)", marginBottom: 32, fontSize: 15 }}>
          这是 animal-island-ui 组件库的预览页，看看是否是你想要的可爱风格
        </p>

        {/* 卡片配色 */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 32 }}>
          {(["app-pink", "warm-peach-pink", "purple", "app-yellow"] as const).map((c) => (
            <Card key={c} color={c} pattern="default" hoverable style={{ padding: 20, textAlign: "center" }}>
              <div style={{ fontSize: 28 }}>🌸</div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>{c}</div>
            </Card>
          ))}
        </div>

        {/* 按钮 */}
        <Card color="app-pink" style={{ padding: 24, marginBottom: 24 }}>
          <Title size="middle">按钮 Button</Title>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 16 }}>
            <Button type="primary">主要按钮</Button>
            <Button type="primary" size="large">大按钮</Button>
            <Button>默认按钮</Button>
            <Button type="dashed">虚线按钮</Button>
            <Button type="text">文字按钮</Button>
            <Button type="primary" ghost>幽灵按钮</Button>
            <Button loading>加载中</Button>
          </div>
        </Card>

        {/* 表单 */}
        <Card color="warm-peach-pink" style={{ padding: 24, marginBottom: 24 }}>
          <Title size="middle">表单控件</Title>
          <div style={{ display: "grid", gap: 16, marginTop: 16, maxWidth: 400 }}>
            <Input placeholder="请输入账号" />
            <Input placeholder="请输入密码" />
            <Select
              placeholder="选择区服"
              value={server}
              onChange={setServer}
              options={[
                { key: "0", label: "官服" },
                { key: "1", label: "B服" },
              ]}
            />
            <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
              <Switch defaultChecked />
              <Radio
                defaultValue="wechat"
                value={payType}
                onChange={setPayType}
                options={[
                  { label: "微信支付", value: "wechat" },
                  { label: "支付宝", value: "alipay" },
                ]}
              />
            </div>
          </div>
        </Card>

        {/* 标签 & 标签页 & 进度 */}
        <Card color="purple" style={{ padding: 24, marginBottom: 24 }}>
          <Title size="middle">标签 / 标签页 / 进度</Title>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "16px 0" }}>
            <Tag color="app-pink">月卡 ¥18</Tag>
            <Tag color="warm-peach-pink">季卡 ¥50</Tag>
            <Tag color="app-yellow">年卡 ¥188</Tag>
            <Tag color="app-green">豪华 ¥68</Tag>
          </div>
          <Tabs
            items={[
              { key: "1", label: "基础包月", children: <div style={{ padding: 16 }}>日常/周常/基建/信用/剿灭</div> },
              { key: "2", label: "豪华包月", children: <div style={{ padding: 16 }}>基础 + 活动/危机合约/引航者</div> },
            ]}
          />
          <div style={{ marginTop: 16 }}>
            <Progress percent={68} />
          </div>
        </Card>

        {/* 套餐卡片示例 */}
        <Title size="large" color="app-pink" style={{ margin: "24px 0 16px" }}>
          🛒 套餐购买卡片示例
        </Title>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
          {[
            { name: "基础月卡", price: 18, days: 30, color: "app-pink" as const },
            { name: "基础季卡", price: 50, days: 90, color: "warm-peach-pink" as const },
            { name: "豪华年卡", price: 768, days: 365, color: "purple" as const },
          ].map((pkg) => (
            <Card key={pkg.name} color={pkg.color} pattern="default" hoverable style={{ padding: 24, textAlign: "center" }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🎁</div>
              <div style={{ fontSize: 18, fontWeight: 800 }}>{pkg.name}</div>
              <div style={{ color: "var(--berry-600)", margin: "8px 0" }}>{pkg.days} 天</div>
              <div style={{ fontSize: 24, fontWeight: 900, color: "var(--berry-300)" }}>¥{pkg.price}</div>
              <Button type="primary" block style={{ marginTop: 16 }}>立即购买</Button>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}